module.exports = __webpack_public_path__ + "img/dcfl01.cd04551d.png";